// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars40: FC<Webinars40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M35.555 34.695V7.778H4.445V21.11H1.667V7.778c0-.769.272-1.424.815-1.965A2.681 2.681 0 0 1 4.445 5h31.11c.764 0 1.418.272 1.962.816.544.544.816 1.198.816 1.962v23.889c0 .787-.266 1.47-.798 2.048a2.982 2.982 0 0 1-1.98.98ZM15 23.305c-1.833 0-3.357-.606-4.57-1.819-1.212-1.213-1.819-2.736-1.819-4.57 0-1.833.607-3.356 1.82-4.569s2.736-1.82 4.569-1.82c1.833 0 3.357.607 4.57 1.82 1.212 1.213 1.819 2.736 1.819 4.57 0 1.833-.607 3.356-1.82 4.57-1.212 1.212-2.736 1.818-4.569 1.818Zm0-2.777c1.028 0 1.887-.345 2.576-1.035.69-.69 1.035-1.549 1.035-2.576 0-1.028-.345-1.887-1.035-2.577S16.028 13.305 15 13.305s-1.886.345-2.576 1.035c-.69.69-1.035 1.549-1.035 2.577 0 1.027.345 1.886 1.035 2.576.69.69 1.548 1.035 2.576 1.035ZM1.667 36.667V32.5c0-1.019.257-1.91.77-2.674a5 5 0 0 1 2.008-1.743c1.814-.842 3.587-1.474 5.319-1.895A22.07 22.07 0 0 1 15 25.555c1.76 0 3.5.216 5.222.646 1.722.43 3.49 1.06 5.303 1.888.849.4 1.529.981 2.04 1.742.512.76.768 1.65.768 2.669v4.167H1.667Zm2.778-2.778h21.11V32.5c0-.398-.113-.773-.34-1.125a2.215 2.215 0 0 0-.854-.792c-1.685-.824-3.273-1.405-4.764-1.743A20.723 20.723 0 0 0 15 28.333c-1.574 0-3.116.17-4.625.507-1.51.338-3.097.92-4.764 1.743-.343.176-.623.44-.84.792a2.104 2.104 0 0 0-.326 1.125v1.389Z" />
        </svg>
    );
};

export default Webinars40;
